import { z } from 'zod';
export const DownloadInvoicePathRequestSchema = z.object({});
export const DownloadInvoiceApiSchema = {
    params: z.object({
        invoiceId: z.string(),
    }),
    headers: z.object({ requestActor: z.string() }),
};
export const DownloadInvoicePathSchema = DownloadInvoiceApiSchema.params;
export const DownloadInvoiceRequestSchema = DownloadInvoiceApiSchema.params.merge(DownloadInvoiceApiSchema.headers);
export const DownloadInvoiceResponseSchema = z.void();
